export function megabytesToBytes(size: number) {
  return size * 1e6;
}
